module.exports = __webpack_public_path__ + "static/media/clock.3f7bffed.svg";